import I18n from 'i18n-js';

export function withPrefix(prefix: string) {
  const t = function (key: string, opt = {}): string {
    return I18n.t(`${prefix}.${key}`, opt);
  };

  return t;
}
